import { useQuery } from "@tanstack/react-query";
import { getJourneyByIntake, getJourneyByRequest, type JourneyDetailDto } from "@/api/endpoints";

/** One journey, entered from a request id or from an intake (source + id). */
export type JourneyEntry = { kind: "request"; id: string } | { kind: "intake"; source: string; id: string };

export function useJourneyDetailQuery(entry: JourneyEntry | null) {
  return useQuery<JourneyDetailDto>({
    queryKey: ["journey", entry?.kind ?? null, entry?.kind === "intake" ? entry.source : null, entry?.id ?? null],
    queryFn: () => (entry!.kind === "request" ? getJourneyByRequest(entry!.id) : getJourneyByIntake(entry!.source, entry!.id)),
    enabled: entry !== null,
    staleTime: 60_000,
  });
}
